import { USER_CHANGE, TAB_CHANGE, SET_USER } from './../actions/userData';

    const userDataReducer = (state = {}, { type, modelPayload }) => {
        switch (type) {
            case USER_CHANGE:
                return { ...state, modelPayload }
            default:
                return state
        }
    };
    
    const tabChangeReducer = (state = {}, { type, tabPayload }) => {
        switch (type) {
            case TAB_CHANGE:
                return { ...state, tabPayload }
            default:
                return state
        }
    };

    const setUserOnView = (state = {}, { type, user }) => {
        switch (type) {
            case SET_USER:
                return { ...state, user }
            default:
                return state
        }
    };
    
    export { userDataReducer, tabChangeReducer, setUserOnView };